<mat-calendar
  [selected]="selectedDate"
  (selectedChange)="selectedDate = $event; dateSelect.next($event)"
  [dateFilter]="dateFilter"
  [minDate]="today"
></mat-calendar>
